export default "__VITE_ASSET__DMrYoWtC__"